module.exports = {
	"config": {
		"siteTitle": "CSE 145",
		"baseColor": "#19647E",
		"theme": "hyde-x",
		"linkPrefix": "/teamUndergradScrubs",
		"backPages": [
			"/background/",
			"/background/who-we-are/",
			"/background/the-project/",
			"/background/old-goals/",
			"/background/new-goals/",
			"/background/about-scripps/"
		],
		"procPages": [
			"/process/",
			"/process/week-1/",
			"/process/week-2/",
			"/process/week-3/",
			"/process/week-4/",
			"/process/week-5/",
			"/process/week-6/",
			"/process/week-7/",
			"/process/week-8/",
			"/process/week-9/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "background",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "background",
				"stem": "_template",
				"path": "background/_template.jsx"
			},
			"requirePath": "background/_template.jsx",
			"templatePath": "/background/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "background/about-scripps",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "background/about-scripps",
				"stem": "index",
				"path": "background/about-scripps/index.md"
			},
			"requirePath": "background/about-scripps/index.md",
			"path": "/background/about-scripps/",
			"data": {
				"title": "About Scripps"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "background",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "background",
				"stem": "index",
				"path": "background/index.md"
			},
			"requirePath": "background/index.md",
			"path": "/background/",
			"data": {
				"title": "Problem Statement"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "background/new-goals",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "background/new-goals",
				"stem": "index",
				"path": "background/new-goals/index.md"
			},
			"requirePath": "background/new-goals/index.md",
			"path": "/background/new-goals/",
			"data": {
				"title": "New Project Goals"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "background/old-goals",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "background/old-goals",
				"stem": "index",
				"path": "background/old-goals/index.md"
			},
			"requirePath": "background/old-goals/index.md",
			"path": "/background/old-goals/",
			"data": {
				"title": "Old Project Goals"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "background/the-project",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "background/the-project",
				"stem": "index",
				"path": "background/the-project/index.md"
			},
			"requirePath": "background/the-project/index.md",
			"path": "/background/the-project/",
			"data": {
				"title": "The Project"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "background/who-we-are",
				"base": "_Demo.jsx",
				"ext": "jsx",
				"name": "_Demo",
				"extname": ".jsx",
				"basename": "_Demo.jsx",
				"dirname": "background/who-we-are",
				"stem": "_Demo",
				"path": "background/who-we-are/_Demo.jsx"
			},
			"requirePath": "background/who-we-are/_Demo.jsx",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "background/who-we-are",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "background/who-we-are",
				"stem": "index",
				"path": "background/who-we-are/index.jsx"
			},
			"requirePath": "background/who-we-are/index.jsx",
			"path": "/background/who-we-are/",
			"data": {
				"title": "Who We Are"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "examples",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "examples",
				"stem": "index",
				"path": "examples/index.md"
			},
			"requirePath": "examples/index.md",
			"path": "/examples/",
			"data": {
				"title": "Some Demos"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md"
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {
				"title": "Underwater Acoustics"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "netlify",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "netlify",
				"stem": "index",
				"path": "netlify/index.md"
			},
			"requirePath": "netlify/index.md",
			"path": "/netlify/",
			"data": {
				"title": "Gatsby on Netlify",
				"date": "2015-12-14T22:12:03.284Z",
				"layout": "post",
				"readNext": "/hi-folks/",
				"path": "/netlify/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "process",
				"stem": "_template",
				"path": "process/_template.jsx"
			},
			"requirePath": "process/_template.jsx",
			"templatePath": "/process/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "process",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process",
				"stem": "index",
				"path": "process/index.md"
			},
			"requirePath": "process/index.md",
			"path": "/process/",
			"data": {
				"title": "Our Weekly Updates"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-1",
				"stem": "index",
				"path": "process/week-1/index.md"
			},
			"requirePath": "process/week-1/index.md",
			"path": "/process/week-1/",
			"data": {
				"title": "Week 1: The Start"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-2",
				"stem": "index",
				"path": "process/week-2/index.md"
			},
			"requirePath": "process/week-2/index.md",
			"path": "/process/week-2/",
			"data": {
				"title": "Week 2: Meeting Ana"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-3",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-3",
				"stem": "index",
				"path": "process/week-3/index.md"
			},
			"requirePath": "process/week-3/index.md",
			"path": "/process/week-3/",
			"data": {
				"title": "Week 3: Broken Code"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-4",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-4",
				"stem": "index",
				"path": "process/week-4/index.md"
			},
			"requirePath": "process/week-4/index.md",
			"path": "/process/week-4/",
			"data": {
				"title": "Week 4: It Runs!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-5",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-5",
				"stem": "index",
				"path": "process/week-5/index.md"
			},
			"requirePath": "process/week-5/index.md",
			"path": "/process/week-5/",
			"data": {
				"title": "Week 5: Continuation"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-6",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-6",
				"stem": "index",
				"path": "process/week-6/index.md"
			},
			"requirePath": "process/week-6/index.md",
			"path": "/process/week-6/",
			"data": {
				"title": "Week 6: Presenting"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-7",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-7",
				"stem": "index",
				"path": "process/week-7/index.md"
			},
			"requirePath": "process/week-7/index.md",
			"path": "/process/week-7/",
			"data": {
				"title": "Week 7: Milestones"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-8",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-8",
				"stem": "index",
				"path": "process/week-8/index.md"
			},
			"requirePath": "process/week-8/index.md",
			"path": "/process/week-8/",
			"data": {
				"title": "Week 8: Updates with Dr. Sirovic"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "process/week-9",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "process/week-9",
				"stem": "index",
				"path": "process/week-9/index.md"
			},
			"requirePath": "process/week-9/index.md",
			"path": "/process/week-9/",
			"data": {
				"title": "Week 9: Almost there"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 385
// module chunks = 0